// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AppController from "./app_controller"
application.register("app", AppController)

import CookiesController from "./cookies_controller"
application.register("cookies", CookiesController)
